"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TodoResult = function () {
  function TodoResult() {}
  TodoResult.KEYTYP_POLNR = 'POL';
  TodoResult.KEYTYP_SCHNR = 'SCH';
  TodoResult.KEYTYP_PER = 'PER';
  TodoResult.STATUS_ERSTELLT = 'J';
  TodoResult.STATUS_TRASH = 'T';
  TodoResult.STATUS_BEARBEITET = 'B';
  TodoResult.STATUS_DRINGEND = 'D';
  TodoResult.STATUS_ERLEDIGT = 'E';
  return TodoResult;
}();
exports.TodoResult = TodoResult;